import React from "react"

import { GridColDef } from "@mui/x-data-grid"

import {
    OrderType,
    PaginatedResponse,
    SearchFilter,
    MicrojobberRequest,
    MicrojobberWrapper,
} from "models"
import { SbPaginatedDatagrid } from "components/commons"

import getMicrojobTableColumns from "./microjob-table-columns"

interface MicrojobTableProps
{
    handleCallback: (data: MicrojobberRequest) => void
    data: PaginatedResponse<MicrojobberWrapper>
}
interface MicrojobTableState
{
    pagination: SearchFilter
}
export class MicrojobTable extends React.Component<MicrojobTableProps, MicrojobTableState>
{
    private readonly columns: GridColDef[]

    constructor(props: MicrojobTableProps)
    {
        super(props)
        this.columns = getMicrojobTableColumns()
        this.state = {
            pagination: {
                pageSize: 10,
                pageId: 0,
                orderBy: "fullName",
                orderType: OrderType.ASCENDING,
            },
        }
    }

    componentDidMount()
    {
        this.props.handleCallback(this.state.pagination as MicrojobberRequest)
    }

    private onPaginationChanged = (pageId: number, pageSize: number): void => {
        this.setState(
            () => ({
                pagination: {
                    ...this.state.pagination,
                    pageSize: pageSize,
                    pageId: pageId,
                },
            }),
            () => this.props.handleCallback(this.state.pagination as MicrojobberRequest)
        )
    }

    private onSortChanged = (orderBy: string|null, orderType: OrderType|null): void => {
        // this.setState(
        //     () => ({
        //         pagination: {
        //             pageSize: this.state.pagination.pageSize,
        //             pageId: this.state.pagination.pageId,
        //             orderBy: orderBy,
        //             orderType: orderType,
        //         },
        //     }),
        //     () => this.props.handleCallback(this.state.pagination as MicrojobberRequest)
        // )
    }

    render()
    {
        return (
            <SbPaginatedDatagrid
                columns={this.columns}
                data={this.props.data}
                pagination={this.state.pagination}
                onPaginationChanged={this.onPaginationChanged}
                onSortChanged={this.onSortChanged}
            />
        )
    }
}
